<template>
  <div class="sign-up">
    <md-card v-cloak>
      <md-card-media>
        <img class="image" src="/static/maxima-logo.svg"/>
      </md-card-media>

      <md-card-header>
        <div class="md-title">Maxima-Online</div>
        <translate tag="div" class="md-subhead">Please sign-up</translate>
      </md-card-header>

      <md-card-content v-if="!submitted">
        <form novalidate @submit.stop.prevent="submit">

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !user.firstname.length && firstnameDirty }">
                <translate tag="label">Firstname</translate>
                <md-input id="signup-firstname" @input.native="firstnameDirty = true" type="text" v-model="user.firstname" required></md-input>
                <span class="md-error"><translate>Firstname must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': !user.lastname.length && lastnameDirty }">
                <translate tag="label">Lastname</translate>
                <md-input id="signup-lastname" @input.native="lastnameDirty = true" type="text" v-model="user.lastname" required></md-input>
                <span class="md-error"><translate>Lastname must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !validEmail(user.email) && emailDirty }">
                <translate tag="label">E-mail</translate>
                <md-input id="signup-email" @input.native="emailDirty = true" type="text" v-model="user.email" required></md-input>
                <span class="md-error"><translate>E-mail must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': user.email !== user.emailConf && emailConfDirty }">
                <translate tag="label">Confirm E-mail</translate>
                <md-input id="signup-email-conf" @input.native="emailConfDirty = true" type="text" v-model="user.emailConf" required></md-input>
                <span class="md-error"><translate>E-mail and confirmation do not match</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !user.password.length && passwordDirty }" md-has-password>
                <translate tag="label">Password</translate>
                <md-input id="signup-pass" @input.native="passwordDirty = true" v-model="user.password" type="password" required></md-input>
                <span class="md-error"><translate>Password must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': user.password !== user.passwordConf && passwordConfDirty }" md-has-password>
                <translate tag="label">Confirm Password</translate>
                <md-input id="signup-pass-conf" @input.native="passwordConfDirty = true" type="password" v-model="user.passwordConf" required></md-input>
                <span class="md-error"><translate>Password and confirmation do not match</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <span class="md-subheading"><translate>Depot:</translate><md-icon class="msg-icon">info<md-tooltip md-direction="right"><translate translate-comment="Help-text in sign-up form">Type the name of the depot to which you want to be assigned (your employer)</translate></md-tooltip></md-icon></span>
          </md-layout>

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !user.customerOrig.length && customerOrigDirty }">
                <translate tag="label">Name of Depot</translate>
                <md-input id="signup-cust-orig" @input.native="customerOrigDirty = true" type="text" v-model="user.customerOrig" required></md-input>
                <span class="md-error"><translate>Depot must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': !user.workphone.length && workphoneDirty }">
                <translate tag="label">Work Phone</translate>
                <md-input id="signup-workphone" @input.native="workphoneDirty = true" type="text" v-model="user.workphone" required></md-input>
                <span class="md-error"><translate>Work phone must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate class="md-subheading">Private Contact:</translate>
          </md-layout>

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !validEmail(user.private.email) && privEmailDirty }">
                <translate tag="label">Private E-mail</translate>
                <md-input id="signup-priv-email" @input.native="privEmailDirty = true" type="text" v-model="user.private.email" :value="user.private.email" required></md-input>
                <span class="md-error"><translate>Private e-mail must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': !user.private.phone.length && privPhoneDirty }">
                <translate tag="label">Private Phone</translate>
                <md-input id="signup-priv-phone" @input.native="privPhoneDirty = true" type="text" v-model="user.private.phone" :value="user.private.phone" required></md-input>
                <span class="md-error"><translate>Private Phone must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate class="md-subheading">Private Address:</translate>
          </md-layout>

          <md-layout>
            <md-input-container :class="{'md-input-invalid': !user.address.street.length && streetDirty }">
              <translate tag="label">Street</translate>
              <md-input id="signup-street" @input.native="streetDirty = true" type="text" v-model="user.address.street" :value="user.address.street" required></md-input>
              <span class="md-error"><translate>Street must be filled</translate></span>
            </md-input-container>
          </md-layout>

          <md-layout md-gutter="24">
            <md-layout class="layout-padding-right">
              <md-input-container :class="{'md-input-invalid': !user.address.postcode.length && postcodeDirty }">
                <translate tag="label">Postal Code</translate>
                <md-input id="signup-postcode" @input.native="postcodeDirty = true" type="text" v-model="user.address.postcode" :value="user.address.postcode" required></md-input>
                <span class="md-error"><translate>Postal Code must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout class="layout-padding-left">
              <md-input-container :class="{'md-input-invalid': !user.address.city.length && cityDirty }">
                <translate tag="label">City</translate>
                <md-input id="signup-city" @input.native="cityDirty = true" type="text" v-model="user.address.city" :value="user.address.city" required></md-input>
                <span class="md-error"><translate>City must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout>
            <translate class="md-subheading">Payment Method:</translate>
              <md-input-container class="input-no-top-margin">
                <md-select v-model="user.payment">
                  <md-option value="0" >{{ trMonthly }}</md-option>
                  <md-option value="1" >{{ trOnDelivery }}</md-option>
                </md-select>
              </md-input-container>
          </md-layout>

        </form>
      </md-card-content>
      <md-card-content v-else class="text-info">
        <translate>An e-mail with further instructions has been sent to the provided address.</translate>
      </md-card-content>

      <md-card-actions v-if="!submitted">
        <md-spinner v-if="spinning" :md-size="20" md-indeterminate></md-spinner>
        <router-link tag="button" to="/sign-in" class="md-primary md-button"><translate>Cancel</translate></router-link>
        <md-button id="signup-button" @click.native="signup" class="md-primary md-raised"><translate>Sign-up</translate></md-button>
      </md-card-actions>
      <md-card-actions v-if="submitted">
        <router-link tag="button" to="/sign-in" class="md-primary md-button"><translate>Return</translate></router-link>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <translate>This e-mail is already registered</translate>
        <md-button @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>
    </md-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import validator from 'validator'

export default {
  name: 'sign-up',
  data () {
    return {
      spinning: false,
      submitted: false,
      user: {
        firstname: '',
        lastname: '',
        email: '',
        emailConf: '',
        password: '',
        passwordConf: '',
        customerOrig: '',
        workphone: '',
        address: {
          street: '',
          postcode: '',
          city: ''
        },
        private: {
          email: '',
          phone: ''
        },
        payment: '0'
      },
      firstnameDirty: false,
      lastnameDirty: false,
      emailDirty: false,
      emailConfDirty: false,
      passwordDirty: false,
      passwordConfDirty: false,

      customerOrigDirty: false,
      workphoneDirty: false,
      streetDirty: false,
      postcodeDirty: false,
      cityDirty: false,
      privEmailDirty: false,
      privPhoneDirty: false
    }
  },
  created () {
    this.userCreate()
  },
  watch: {
    language (lang) {
      this.onChangeLang(this.user.payment)
    }
  },
  computed: {
    ...mapGetters([
      'alreadyRegistered'
    ]),
    trMonthly () {
      return this.$gettext('Monthly')
    },
    trOnDelivery () {
      return this.$gettext('On Delivery')
    },
    language () {
      return this.$language.current
    }
  },
  methods: {
    onChangeLang (value) {
      // force fields to change ...
      this.user.payment = ''

      Vue.nextTick(() => {
        // ... and change them back to original values
        this.user.payment = value
      })
    },
    signup () {
      this.firstnameDirty = true
      this.lastnameDirty = true
      this.emailDirty = true
      this.emailConfDirty = true
      this.passwordDirty = true
      this.passwordConfDirty = true
      this.customerOrigDirty = true
      this.workphoneDirty = true
      this.streetDirty = true
      this.postcodeDirty = true
      this.cityDirty = true
      this.privEmailDirty = true
      this.privPhoneDirty = true

      this.spinning = true
      if ([
        this.user.firstname,
        this.user.lastname,
        this.user.password,
        this.user.customerOrig,
        this.user.workphone,
        this.user.address.street,
        this.user.address.postcode,
        this.user.address.city,
        this.user.private.phone
      ].every(this.notEmpty) && this.validEmail(this.user.email) && this.validEmail(this.user.private.email) && !this.submitted) {
        this.createUser({ signUpUser: this.user, lang: Vue.config.language })
          .then(() => {
            if (this.alreadyRegistered) {
              this.$refs.snackbar.open()
              this.userCancelError()
            } else {
              this.submitted = true
              // email is sent
            }
            this.spinning = false
          })
          .catch((err) => {
            console.log(err)
            this.spinning = false
          })
      } else {
        this.spinning = false
      }
    },
    ...mapMutations([
      'userCreate',
      'userCancelError'
    ]),
    ...mapActions([
      'createUser'
    ]),
    notEmpty (value) {
      return value !== ''
    },
    validEmail (email) {
      return validator.isEmail(email)
    }
  }
}
</script>

<style scoped>
[v-cloak] {
  display: none!important;
}
.sign-up {
  width: 45rem;
  margin: 5em auto;
}
.image {
  width: 60% !important;
  padding: 30px 30px 10px 30px;
}
.msg-icon {
  color: rgba(10, 81, 181, .35);
  font-size: 20px;
}
.heading-section {
  margin-top: 10px;
  margin-bottom: 10px;
}
.input-no-top-margin {
  margin-top: 0;
}
.md-input-container label {
  color: rgba(0, 0, 0, .45);
}
.layout-padding-right {
  padding-right: 16px !important;
}
.layout-padding-left {
  padding-left: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/SignUp.vue